import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  USER_GAME_PROFILE_FEATURE_KEY,
  UserGameProfileState,
} from './user-game-profile.reducer';
import { RouterSelectors } from '@fantaz/core/router';

// Lookup the 'UserGameProfile' feature state managed by NgRx
export const getUserGameProfileState =
  createFeatureSelector<UserGameProfileState>(USER_GAME_PROFILE_FEATURE_KEY);

export const getUserGameProfileSaving = createSelector(
  getUserGameProfileState,
  (state: UserGameProfileState) => state.saving,
);

export const getUserGameProfileError = createSelector(
  getUserGameProfileState,
  (state: UserGameProfileState) => state.error,
);

export const selectRequiredVerificationParam = RouterSelectors.selectQueryParam(
  'requireVerification',
);

export const selectRequiredVerification = createSelector(
  selectRequiredVerificationParam,
  (requireVerification) => requireVerification == 'true',
);
